import { motion } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { withPrefix } from 'gatsby'
import React, { useState } from 'react'
import { useStore } from '../../../../../../hooks/useStore';
import { PillButton } from '../../../../../general/buttons/pill-button';
import { SmartLink } from '../../../../../general/link';
import RichText from '../../../../../general/rich-text/RichText';
// import { PillButton } from '../../../../../general/buttons/pill-button';
// import {PillButton} from '../../../../general/buttons/pill-button'
const MapPointOfInterestMenu = observer(({data, index}) => {

    const [isOpen, setOpen] = useState();
    // return null;
    
    return (
        <div
            className={isOpen ? "map-poi open" : "map-poi"}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <div 
                style={{borderRadius: 8}} 
                className="menu"
            >
                    <div className='text'>
                        <RichText>
                            {data.description}
                        </RichText>
                    </div>
                
            </div>

            <a 
                href={data.website}
                target="_blank"
            >
                <PillButton invert={isOpen ? true : false} actionType="external-link" action={data.website} noHover noScale>{data.name}</PillButton>
            </a>

            <img src={withPrefix('/images/home-arrow.svg')} alt="" />


            <style jsx>{`
                .map-poi {
                    position: absolute;
                    
                    left: 50%;
                    top: -35px;
                    transform: translateX(-50%);
                    text-align: center;
                }

                .open {
                    z-index: 5;
                }

                img {
                    width: 30px;
                    position: absolute;
                    bottom: -40px;
                    left: 50%;
                    animation: float 3s ease-in-out infinite;
                    animation-delay: ${-data.name.length * 9}s;
                    opacity: 1;
                    transition: opacity .55s ease-out .14s;

                }


                .open img {
                    opacity: 0;
                    transition: opacity .05s ease;
                }

                @keyframes float {
                    0% {
                        transform: translateY(0px) translateX(-50%);
                    }
                    50% {
                        transform: translateY(-5px) translateX(-50%);
                    }
                    100% {
                        transform: translateY(0px) translateX(-50%);
                    }
                }

                .map-poi :global(p) {
                    font-size: var(--font--xs);
                }
                
                .map-poi :global(.pill-button .backdrop) {
                    background: rgba(0,0,0,.8);
                }

                .map-poi :global(.pill-button h6) {
                    white-space: nowrap;
                }

                h5 {
                    margin-bottom: 12px;
                }

                .menu{
                    position: absolute;
                    height: 100%;
                    background: rgba(0,0,0,.8);
                    color: white;
                    padding: 20px;    
                    padding-top: 65px;
                    top: -20px;
                    left: 50%;
                    width: 330px;
                    transform: translateX(-50%);
                    height: auto;    
                    opacity: 0;
                    transition: opacity .3s ease-out;
                    pointer-events: none;
                }



                .open .menu {
   
                    opacity: 1;
                    transition: opacity .35s ease-out .14s;

                } 

                .text {
                    opacity: 0;
                    transform: translateY(8px);
                    transition: opacity .6s ease, transform .6s ease;

                }

                .open .text {
                    opacity: 1;
                    transform: translateY(0px);
                    transition: opacity .5s ease .28s, transform .3s ease-out .28s;
                }
                    
 

            `}</style>
        </div>  
    )
})

export default MapPointOfInterestMenu